import { render, staticRenderFns } from "./ProjectView.vue?vue&type=template&id=0f6f374a&scoped=true"
import script from "./ProjectView.vue?vue&type=script&lang=js"
export * from "./ProjectView.vue?vue&type=script&lang=js"
import style0 from "./ProjectView.vue?vue&type=style&index=0&id=0f6f374a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f374a",
  null
  
)

export default component.exports